import firebase from "@/firebase";

export default {
  namespaced: true,
  state: {
    resources: [],
    states: [
      "AL",
      "AK",
      "AS",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DE",
      "DC",
      "FM",
      "FL",
      "GA",
      "GU",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MH",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "MP",
      "OH",
      "OK",
      "OR",
      "PW",
      "PA",
      "PR",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VI",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
    ],
    stages: [
      "Pre-Diagnosis",
      "Diagnosis",
      "Early Intervention",
      "Schools",
      "College & Vocational",
      "Employment",
      "Housing",
    ],
    types: [
      "ABA Services",
      "Community Life",
      "Diagnosis",
      "Education Services",
      "Employment",
      "Family Support",
      "Finance and medicaid",
      "Health and medical",
      "Housing",
      "Information",
      "Legal/advocacy",
      "Miscellaneous",
      "School",
      "Therapy",
    ],
  },
  getters: {
    getResources(state) {
      return state.resources;
    },
    getStages(state) {
      return state.stages;
    },
    getStates(state) {
      return state.states;
    },
    getTypes(state) {
      return state.types;
    },
  },
  mutations: {
    addResource(state, data) {
      state.resources.push(data);
    },
    removeResource(state, id) {
      const i = state.resources.findIndex((a) => a.id === id);
      state.resources.splice(i, 1);
    },
    setResource(state, data) {
      const i = state.resources.findIndex((a) => a.id === data.id);
      state.resources[i] = data;
    },
    setResources(state, data) {
      state.resources = data;
    },
  },
  actions: {
    async listResources(state, id) {
      let resources = [];
      if (!id) {
        const refs = await firebase.db
          .collection("resources")
          .orderBy("name")
          .get();
        refs.forEach((ref) => resources.push(ref.data()));
      } else {
        const profile = await firebase.db
          .collection("profiles")
          .doc(id)
          .get();
        resources = profile.data().resources || [];
        if (resources.length > 0) {
          resources = [];
          let refs = await profile.data().resources.map(async (r) => {
            return await firebase.db
              .collection("resources")
              .doc(r)
              .get();
          });
          refs = await Promise.all(refs);
          refs.forEach((ref) => resources.push(ref.data()));
        }
      }
      state.commit("setResources", resources);
    },
    async createResource(state, data) {
      const resource = await firebase.db.collection("resources").add(data);
      resource.update({ id: resource.id });
      data.id = resource.id;
      state.commit("addResource", data);
    },
    async deleteResource(state, id) {
      await firebase.db
        .collection("resources")
        .doc(id)
        .delete();
      state.commit("removeResource", id);
    },
    async findResources(state, filters) {
      if (
        !filters.city &&
        !filters.state &&
        !filters.type &&
        !filters.stage &&
        !filters.keyword
      ) {
        state.commit("setResources", []);
        return;
      }

      let refs = await firebase.db.collection("resources").orderBy("name");
      if (filters.city) {
        refs = await refs.where("city", "==", filters.city);
      }
      if (filters.state) {
        refs = await refs.where("state", "==", filters.state);
      }

      let results = await refs.get();
      let resources = [];
      results.forEach(r => {
        const data = r.data();
        if (filters.type) {
          if (!data.types.includes(filters.type)) {
            return;
          }
        }
        if (filters.stage) {
          if (!data.stages.includes(filters.stage)) {
            return;
          }
        }
        if (filters.keyword) {
          const name = data.name.toLowerCase();
          const description = data.description
            ? data.description.toLowerCase()
            : "";
          const keyword = filters.keyword.toLowerCase();
          if (!name.includes(keyword) && !description.includes(keyword)) {
            return;
          }
        }
        resources.push(data);
      });
      state.commit("setResources", resources);
    },
    async updateResource(state, data) {
      await firebase.db
        .collection("resources")
        .doc(data.id)
        .update(data);
      state.commit("setResource", data);
    },
  },
};
